import {createAction, createReducer} from 'redux-act';
import {AxiosResponse} from 'axios';

import {HTO_PDP_MODE} from 'constants/homeTryOn/homeTryOn';
import {fetchQuoteItemV2} from 'actions/cart/cart';
import {QuoteItemV2Type} from 'constants/flow/flowTypesCart';

type ProductHtoReducerType = {
    mode: $Values<typeof HTO_PDP_MODE>;
    enabled: boolean;
};

const defaultState = {
    mode: HTO_PDP_MODE.NO_HTO,
    enabled: false,
};

// actions
export const setHtoMode = createAction<$Values<typeof HTO_PDP_MODE>>('SET_HTO_MODE');
export const setHtoEnabled = createAction<boolean>('SET_HTO_ENABLED');

// reducers
export const productHto = createReducer<ProductHtoReducerType>({}, defaultState);

productHto.on(setHtoMode, (state, payload) => ({...state, mode: payload}));
productHto.on(setHtoEnabled, (state, payload) => ({...state, enabled: payload}));
productHto.on(
    `${fetchQuoteItemV2}_FULFILLED`,
    (state, {data: {productAsHTO}}: AxiosResponse<QuoteItemV2Type>) => ({
        ...state,
        enabled: productAsHTO,
    }),
);
